<!-- 折线图 -->
<style lang="stylus" scoped>
.bar-wrap {
  height: 22vh;
  width: 20vw;
  margin-top: -1.8vh;
  background: url('../../../../../assets/img/industryInformation/line-bg1.png') no-repeat;
  background-size: 100% 100%;
}

.line4 {
  height: 20vh;
  width: 20vw;

  .main {
    width: 100%;
    height: 100%;
  }
}
</style>

<template>
  <div class="bar-wrap">
    <div class="line4">
      <div class="main"></div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import boxWrap from 'components/dashboard/common/boxWrap';
export default {
  data() {
    return {
      myChart: {}
    }
  },
  components: {
    boxWrap
  },
  methods: {
    init() {
      window.addEventListener('resize', function () {
        this.myChart.resize()
      }.bind(this))
    }
  },
  mounted() {
    // 基于准备好的dom，初始化echarts实例
    this.myChart = echarts.init(document.querySelector('.line4 .main'));
    const option = {
      title: {
        text: '日均气温差',
        left: 'center',
        top: '13%',
        textStyle: {
          color: '#fff',
          fontSize: 14
        }
      },
      grid: { // 设置图表位置
        left: '15%',
        bottom: '20%',
        top: '35%'
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: ['春', '夏', '秋', '冬'],
        axisTick: {
          show: false
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: "#243C7E",
            width: 1,
            type: "solid"
          }
        },
        axisLabel: {
          show: true,
          textStyle: {
            color: "#77CAD8"
          }
        },
        splitLine: {
          show: false
        }
      },
      yAxis: {
        type: 'value',
        name: '℃',
        splitNumber: 3,
        axisTick: {
          show: false
        },
        nameTextStyle: {
          color: "#77CAD8"
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: "#243C7E",
            width: 1,
            type: "solid"
          }
        },
        axisLabel: {
          show: true,
          formatter: "{value}",
          textStyle: {
            color: "#77CAD8"
          }
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: "#4797FA",
            width: 1,
            opacity: 0.3,
            type: "solid"
          }
        }
      },
      series: [{
        data: [26, 32, 32, 28],
        type: 'line',
        smooth: true,
        showSymbol: false,
        lineStyle: {
          normal: {
            width: 0
          }
        },
        areaStyle: {
          opacity: 1,
          normal: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: '#FF813C'
            }, {
              offset: 1,
              color: '#FFE63D'
            }], false)
          }
        },
        itemStyle: {
          normal: {
            color: '#f00'
          }
        }
      }, {
        data: [19, 25, 26, 22],
        type: 'line',
        smooth: true,
        showSymbol: false,
        lineStyle: {
          normal: {
            width: 0
          }
        },
        areaStyle: {
          opacity: 1,
          normal: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: '#E4A537'
            }, {
              offset: 1,
              color: '#FFE63D'
            }], false)
          }
        },
        itemStyle: {
          normal: {
            color: '#f00'
          }
        }
      }]
    }
    this.myChart.setOption(option)
    this.init();
  }
}

</script>



// WEBPACK FOOTER //
// index.vue?389d42a6